const backendurl = 'https://api.careernaksha.com';
//const backendurl = 'http://localhost:3000';
const dashboardurl = 'https://app.careernaksha.com';
//const dashboardurl = 'http://localhost:5173';
const communityurl = 'https://community.careernaksha.com';
//const communityurl = 'http://localhost:3001';

export { backendurl, dashboardurl, communityurl };
